<template>
  <header
    class="text-white flex justify-between items-center bg-blue z-30 w-full px-4 md:px-0 md:py-0 py-4 h-[70px]"
    :class="[
      {
        'md:bg-transparent md:justify-end fixed md:relative top-0': !isVerifyEmailRoute && $auth.check() && !isLoginRoute,
      },
      {
        'md:px-8 md:relative': isVerifyEmailRoute,
      },
    ]"
  >
    <!-- hamburger menu to open sideBar in mobile-->
    <div @click="toggleSidebar" class="h-9 cursor-pointer block" :class="[{ 'md:hidden': $auth.check() && !isLoginRoute }]">
      <span v-if="$auth.check() && !isVerifyEmailRoute && !isLoginRoute" class="inline-block w-7 ml-7 cursor-pointer transform -translate-x-1/2 -translate-y-1/2">
        <div
          aria-hidden="true"
          id="close-mobile-menu"
          class="block absolute h-0.5 w-6 bg-white transform transition duration-500 ease-in-out"
          :class="{ 'rotate-45': isSidebarOpen, ' -translate-y-2': !isSidebarOpen }"
        ></div>
        <div
          id="middle-menu-line"
          aria-hidden="true"
          class="block absolute h-0.5 w-6 bg-white transform transition duration-500 ease-in-out"
          :class="{ 'opacity-0': isSidebarOpen }"
        ></div>
        <div
          aria-hidden="true"
          id="open-mobile-menu"
          class="block absolute h-0.5 w-6 bg-white transform transition duration-500 ease-in-out"
          :class="{ '-rotate-45': isSidebarOpen, ' translate-y-2': !isSidebarOpen }"
        ></div>
      </span>
    </div>

    <!-- Logo for mobile -->
    <span
      :class="[
        { 'md:block md:absolute md:left-1/2 md:transform md:-translate-x-1/2': isVerifyEmailRoute, 'md:hidden': !isVerifyEmailRoute && $auth.check() && !isLoginRoute },
        'block',
      ]"
    >
      <a :href="'/' + Language + '/'">
        <img src="../assets/img/plexytrade-logo-white.svg" class="maxMd:max-w-[92%]" width="185" />
      </a>
    </span>

    <!-- Language and profile pop up -->
    <div class="flex justify-end gap-2 items-center" :class="[{ 'ltr:md:ml-auto rtl:md:mr-auto': isVerifyEmailRoute }]">
      <div
        v-if="$auth.check() && !isLoginRoute"
        class="font-semibold text-base hidden md:block ltr:text-right rtl:text-left"
        :class="[isVerifyEmailRoute ? 'text-white' : 'text-blue']"
        v-html="greetingMessage"
      />
      <language-popover :class="{ 'ltr:md:mr-4 rtl:md:ml-4': isLoginRoute || !$auth.check() }" />
      <profile-popover
        v-if="$auth.check() && !isLoginRoute"
        :first_name="clientInfo.first_name"
        :last_name="clientInfo.last_name"
        :coName="clientInfo.coName"
        :emailAddress="clientInfo.emailAddress"
        :verified="isVerified"
        @log-out="logout()"
      ></profile-popover>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import LanguagePopover from './Language.vue'
import ProfilePopover from './ProfilePopover.vue'
export default {
  props: {
    toggleSidebar: {
      type: Function,
      required: true,
    },
    logout: {
      type: Function,
      required: true,
    },
    isSidebarOpen: {
      type: Boolean,
      required: true,
    },
    isVerified: {
      type: Boolean,
    },
    clientInfo: {
      type: Object,
      required: true,
    },
    isEmailVerified: {
      type: Boolean,
    },
  },
  components: {
    ProfilePopover,
    LanguagePopover,
  },
  data() {
    return {
      sideMenuVisibility: false,
    }
  },
  computed: {
    greetingMessage() {
      if (this.clientInfo && this.clientInfo.userInfoFirstName) {
        return `<span class="font-normal">${this.$t('hello')},</span> ${this.clientInfo.userInfoFirstName}`
      }
      return '' // Return empty string if clientInfo or userInfoFirstName doesn't exist
    },

    isVerifyEmailRoute() {
      // Check if the current route name is 'Verify Email'
      return this.$route.name === 'Verify Email'
    },
     isLoginRoute() {
      // Check if the current route name is 'Verify Email'
      return this.$route.name === 'Login'
    },

    ...mapGetters({
      Language: 'language/code',
    }),
  },
  methods: {
    showSideMenu() {
      this.sideMenuVisibility = !this.sideMenuVisibility
    },
  },
}
</script>
